export default {"src":"/_next/static/media/beer-fallback.f83ec333.svg","height":320,"width":320};